import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';

const CotisationChoixCreate = ({handleReload, maxordre, choixCotisationIdSel}) => {
    const [formData, setFormData] = useState({
        cotisation_id: choixCotisationIdSel,
        ordre: maxordre+1,
        libelle: '',
        tribu_montant: 0,
    });
    const url = localStorage.getItem('url');
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Envoi des données via Fetch POST
        console.log('formData', formData, JSON.stringify({...formData}));
        fetch(`${url}CreateChoix/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({...formData, last_ordre: maxordre+1}),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('Réponse du serveur :', data);
                handleReload();
                // Traitez la réponse du serveur si nécessaire
            })
            .catch((error) => {
                console.error('Erreur:', error);
            });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group controlId="ordre">
                <Form.Label>Ordre</Form.Label>
                <Form.Control
                    type="number"
                    name="ordre"
                    value={formData.ordre}
                    onChange={handleChange}
                />
            </Form.Group>

            <Form.Group controlId="libelle">
                <Form.Label>Libelle</Form.Label>
                <Form.Control
                    type="text"
                    name="libelle"
                    value={formData.libelle}
                    onChange={handleChange}
                />
            </Form.Group>

            <Form.Group controlId="montant">
                <Form.Label>Montant</Form.Label>
                <Form.Control
                    type="number"
                    name="montant"
                    value={formData.montant}
                    onChange={handleChange}
                />
            </Form.Group>
            <Button variant="primary" type="submit">
                Soumettre
            </Button>
        </Form>
    );
};

export default CotisationChoixCreate;
